import React from 'react';
import Input from 'antd/es/input';
import Button from 'antd/es/button';
import Form from 'antd/es/form';

import Text from 'antd/es/typography/Text';
import Icon from 'components/Icon';

const ResetPasswordForm = ({ onSubmit, requiresCode, isLoading,validatePassword,setPassword,passwordConditions  }) => (
  <Form
    layout="vertical"
    hideRequiredMark={true}
    initialValues={{}}
    onFinish={onSubmit}
    style={{ width: '360px' }}
    rules={[
      {
        validator: (_, value) => {
          const conditions = validatePassword(value || '');
          if (Object.values(conditions).every((valid) => valid)) {
            return Promise.resolve();
          }
          return Promise.reject(new Error('Password does not meet requirements.'));
        },
      },
    ]}
  > 
    {requiresCode && (<Form.Item
      name="resetCode"
      label="Reset Code"
      rules={[
        {
          required: true,
          message: 'Please enter reset code',
        },
      ]}
    >
      <Input
        prefix={<Icon name="hash" size={16} />}
        size="large"
        placeholder="Enter reset code"
        autoComplete="enter-reset-code"
      />
    </Form.Item>)}

    <Form.Item
      name="newPassword"
      label="New Password"
      rules={[
        {
          required: true,
          message: 'Please enter your new password',
        },
      ]}
    >
      <Input.Password
        prefix={<Icon name="lock" size={16} />}
        type="password"
        size="large"
        placeholder="Enter your new password"
        autoComplete="new-password"
        onChange={(e) => setPassword(e.target.value)}
      />
    </Form.Item>
    <ul>
      <Text>Password must:</Text>
        {Object.entries(passwordConditions).map(([key, value]) => (
          <li key={key} style={{ color: value ? 'green' : 'black' }}>
            {key === 'length' && 'Be a minimum of 8 characters'}
            {key === 'uppercase' && 'Include at least one uppercase letter (A-Z)'}
            {key === 'lowercase' && 'Include at least one lowercase letter (a-z)'}
            {key === 'number' && 'Include at least one number'}
            {key === 'specialChar' && 'Include at least one special character'}
          </li>
        ))}
      </ul>
    <Form.Item>
      <Button type="primary" htmlType="submit" style={{ width: '100%' }} loading={isLoading} disabled={isLoading} size="large">
        Change Password
      </Button>
    </Form.Item>
  </Form>
);

export default ResetPasswordForm;
